module.exports = __webpack_public_path__ + "media/site_templates/www.hirecleaners.com.au/images/our_services_3-3f43cc889659e5b5fbe3d13b6b183b76.jpg";